import { fromUnixTime } from 'date-fns';

export function getAbTestFeatureStartedAt(abTest) {
  return abTest?.publishedAt ?? abTest?.createdAt ?? null;
}

export function getPickerDateRange({ dateRange, stoppedAt, getConvertedDateRange }) {
  if (!dateRange) return null;

  if (dateRange.special) {
    const specialDateRange = getConvertedDateRange(
      { special: dateRange.special },
      stoppedAt && fromUnixTime(stoppedAt),
    );

    if (!specialDateRange) return null;

    return {
      start_date: fromUnixTime(specialDateRange.startDate),
      end_date: fromUnixTime(specialDateRange.endDate),
    };
  }

  if (!dateRange.start_date || !dateRange.end_date) return null;

  return dateRange;
}
